if (!customElements.get('currency-form')) {
  customElements.define(
    'currency-form',
    class CurrencyForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          select: this.querySelector('select[name="currency"]'),
        };
        this.elements.select.addEventListener('change', this.onCurrencyChange.bind(this));
      }

      onCurrencyChange(event) {
        event.preventDefault();
        const form = this.elements.select.closest('form');
        const selectedOption = this.elements.select.options[this.elements.select.selectedIndex];
        console.log('Currency changed to', selectedOption.value);
        if (form) {
          form.submit();
        }
      }
    }
  );
}
